// extracted by mini-css-extract-plugin
module.exports = {"blocked":"src-components-AppDetailsDistribution-ClientsLinked-ClientsLinked-module__blocked--nk981"};